import { connect } from 'react-redux';
import { closeConfigurationRequiredDialog } from '../actions';
import ConfigurationRequiredDialog from '../components/ConfigurationRequiredDialog';
import { getConfigurationRequiredDialogPage } from '../selectors';

const mapStateToProps = state => getConfigurationRequiredDialogPage(state);

const mapDispatchToProps = dispatch => {
    return {
        onClose: () => dispatch(closeConfigurationRequiredDialog()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfigurationRequiredDialog);
